import script from "./ErrorId.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ErrorId.vue?vue&type=script&lang=js"
export * from "./ErrorId.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ErrorId.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/error-page/ErrorId.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d8fc1bf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d8fc1bf', __exports__)) {
    api.reload('6d8fc1bf', __exports__)
  }
  
}


export default __exports__